<template>
  <div>
    <!-- 录入订单 -->
    <a-drawer
        v-model:visible="orderShow"
        :closable="false"
        :destroyOnClose="true"
        :mask="false"
        :maskClosable="false"
        :width="500"
        class="custom-class"
        placement="right"
    >
      <div class="order-box">
        <div class="det-head">
          <div class="f-20 f-c-999 close" @click="orderShow = false">
            <close-outlined/>
          </div>
          <a-tabs v-model:activeKey="activeKey" @change="handleChangeTabs">
            <a-tab-pane :key="1" tab="录入订单">
              <div class="box-house">
                <div class="house-title">
                  <div class="title_img">
                    <a-image
                        :src="imgCut(houseInfo.image || companyInfo.logo, 's')"
                        fit="fill"
                        style="width: 100px; height: 70px"
                    />
                  </div>
                  <div class="title_name">
                    <div class="room-info" @click="showSelectRoom = true">
                      <div>{{ houseInfo.name || "请选择房间" }}</div>
                      <div>
                        <down-outlined/>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="house-date">
                  <div class="date-time">
                    <div class="time-top">
                      <!-- {{ selHouse[0] }} -->
                      <a-date-picker
                          :allowClear="false"
                          :disabledDate="disableStime"
                          :value="selStime"
                          valueFormat="YYYY-MM-DD"
                          @change="stimeChange"
                      />
                    </div>
                    <div class="time-bom">
                      {{
                        "周" +
                        "日一二三四五六".charAt(new Date(selStime).getDay())
                      }}入住
                    </div>
                  </div>
                  <div class="date-night">
                    <span>共</span>
                    <span style="color: #dd0054; font-weight: bold">{{
                        diffDate(selStime, selEtime).length - 1
                      }}</span>
                    <span>晚</span>
                  </div>
                  <div class="date-time">
                    <div class="time-top">
                      <!-- {{
                dayjs(selHouse[selHouse.length - 1])
                  .add(1, "day")
                  .format("YYYY-MM-DD")
              }} -->
                      <a-date-picker
                          :allowClear="false"
                          :disabledDate="disableEtime"
                          :value="selEtime"
                          valueFormat="YYYY-MM-DD"
                          @change="etimeChange"
                      />
                    </div>
                    <div class="time-bom">
                      {{
                        "周" +
                        "日一二三四五六".charAt(new Date(selEtime).getDay())
                      }}离店
                    </div>
                  </div>
                </div>
              </div>
              <div class="box-person">
                <div class="person-title">
                  <div class="title-left">入住人</div>
                  <div
                      class="title-right"
                      @click="
                      addPersonShow = true;
                      addType = 1;
                    "
                  >
                    添加
                  </div>
                </div>
                <div class="person-list">
                  <div class="list_cont">
                    <div
                        v-for="(item, index) in personList"
                        :key="index"
                        class="list-cell"
                    >
                      <div class="cell-name">{{ item.name }}</div>
                      <div class="cell-phone">{{ item.phone }}</div>
                      <div class="cell-phone">{{ item.idcard }}</div>
                      <div class="cell-oper">
                        <span class="oper-del" @click="handleDelPerson(index)"
                        >删除</span
                        >
                        <span
                            class="oper-edit"
                            @click="handleEditPerson(item, index)"
                        >编辑</span
                        >
                      </div>
                    </div>
                  </div>
                  <!-- 填写入住人信息 -->
                  <div v-if="addPersonShow" class="list_inp">
                    <a-form
                        ref="personRef"
                        :label-col="{ span: 4 }"
                        :model="personForm"
                        :wrapper-col="{ span: 18 }"
                        autocomplete="off"
                        labelAlign="left"
                    >
                      <a-form-item
                          :rules="[{ required: true, message: '请输入姓名' }]"
                          label="姓名"
                          name="name"
                      >
                        <a-input
                            v-model:value="personForm.name"
                            allowClear
                            placeholder="姓名"
                        />
                      </a-form-item>
                      <a-form-item
                          :rules="[
                          {
                            required: true,
                            validator: verifyPhone,
                            trigger: 'blur',
                          },
                        ]"
                          label="手机"
                          name="phone"
                      >
                        <a-input
                            v-model:value="personForm.phone"
                            allowClear
                            placeholder="手机"
                        />
                      </a-form-item>
                      <a-form-item
                          :rules="[
                          {
                            required: true,
                            validator: verifyIdcard,
                            trigger: 'blur',
                          },
                        ]"
                          label="身份证"
                          name="idcard"
                      >
                        <a-input
                            v-model:value="personForm.idcard"
                            allowClear
                            placeholder="身份证"
                        />
                      </a-form-item>
                    </a-form>
                    <div class="person_add">
                      <span class="add_confirm" @click="handleConfirmAdd"
                      >确定</span
                      >
                      <span class="add_cancel" @click="addPersonShow = false"
                      >取消</span
                      >
                    </div>
                  </div>
                </div>
              </div>

              <div class="box-info">
                <div class="info-title">订单信息</div>
                <div class="info-form">
                  <a-form
                      ref="orderRef"
                      :hideRequiredMark="true"
                      :label-col="{ span: 5 }"
                      :model="orderForm"
                      :wrapper-col="{ span: 17 }"
                      autocomplete="off"
                      labelAlign="left"
                  >
                    <a-form-item
                        :rules="[{ required: true, message: '请选择来源' }]"
                        label="来源"
                        name="origin"
                    >
                      <a-select
                          v-model:value="orderForm.origin"
                          placeholder="请选择来源"
                      >
                        <a-select-option
                            v-for="item in searchList.source?.list"
                            :key="item.id"
                            :value="item.id"
                        >{{ item.name }}
                        </a-select-option
                        >
                      </a-select>
                    </a-form-item>
                    <a-form-item
                        v-if="orderForm.origin !== 1"
                        label="单号"
                        name="orderNum"
                    >
                      <a-input
                          v-model:value="orderForm.orderNum"
                          allowClear
                          placeholder="来源平台单号（选填）"
                      />
                    </a-form-item>
                    <a-form-item label="房费" name="housePrice">
                      <a-input
                          v-model:value="orderForm.housePrice"
                          allowClear
                          placeholder="房费（选填）"
                      />
                    </a-form-item>
                    <a-form-item label="佣金" name="commission">
                      <a-input
                          v-model:value="orderForm.commission"
                          allowClear
                          placeholder="佣金（选填）"
                      />
                    </a-form-item>
                    <a-form-item
                        :rules="[{ required: true, message: '请输入押金' }]"
                        label="押金"
                        name="cash"
                    >
                      <a-input
                          v-model:value="orderForm.cash"
                          allowClear
                          placeholder="押金，0则免押"
                      />
                      <!-- <a-select v-model:value="orderForm.cash" placeholder="请选择押金">
                <a-select-option
                  v-for="item in searchList.deposit?.list"
                  :key="item.id"
                  :value="item.num"
                  >{{ item.num }}</a-select-option
                >
              </a-select> -->
                    </a-form-item>
                    <a-form-item
                        :rules="[{ required: true, message: '请选择收款方式' }]"
                        label="收款方式"
                        name="payeeMode"
                    >
                      <a-select
                          v-model:value="orderForm.payeeMode"
                          placeholder="请选择收款方式"
                      >
                        <a-select-option
                            v-for="item in searchList.paytype?.list"
                            :key="item.id"
                            :value="item.id"
                        >{{ item.name }}
                        </a-select-option
                        >
                      </a-select>
                    </a-form-item>
                    <a-form-item label="备注" name="remark">
                      <a-textarea
                          v-model:value="orderForm.remark"
                          :rows="4"
                          allowClear
                          placeholder="备注信息"
                      />
                    </a-form-item>
                  </a-form>
                </div>
              </div>
            </a-tab-pane>
            <a-tab-pane v-if="showDayRemark" :key="2" tab="日期备忘">
              <a-textarea
                  v-model:value="dayRemark"
                  :auto-size="{ minRows: 5 }"
                  allowClear
                  placeholder="备忘信息，如（已约保洁）"
              />
              <div style="margin-top: 20px">
                <a-button type="primary" @click="saveDateRemark">保存</a-button>
              </div>
            </a-tab-pane>
          </a-tabs>
        </div>
      </div>
      <template #footer>
        <a-button :loading="loading" type="primary" @click="handleSaves"
        >保存
        </a-button
        >
        <a-button style="margin-left: 8px" @click="handleCancel">关闭</a-button>
      </template>
    </a-drawer>
    <SelectRoom
        v-model:visible="showSelectRoom"
        :endDate="selEtime"
        :startDate="selStime"
        @change="changeRoom"
    ></SelectRoom>
  </div>
</template>

<script>
/* 
  params : {
    hid: 房间id  Number
    date: 日期   Array
    show: 弹窗   Boolean
  }
*/

import {reactive, toRefs, watch} from "vue";
import {addOrder, getDayRemark, getSearchList, houseDetails, updateDayRemark,} from "@/api/api";
import {verifyIdcard, verifyPhone, verifyPrice} from "@/common/validator";
import dayjs from "dayjs";
import useUtils from "@/hooks/useUtils.js";
import {message, Modal} from "ant-design-vue";
import {CloseOutlined, DownOutlined} from "@ant-design/icons-vue";
import SelectRoom from "../SelectRoom/SelectRoom.vue";

export default {
  components: {
    CloseOutlined,
    SelectRoom,
    DownOutlined,
  },
  props: {
    params: {
      default: {},
    },
    showDayRemark: {
      type: Boolean,
      default: false,
    },
    tab: {
      default: 1,
    },
  },
  setup(props, context) {
    const {imgCut, diffDate} = useUtils();
    const room = reactive({
      showSelectRoom: false,
      changeRoom(e) {
        orders.houseInfo = e;
      },
    });
    const orders = reactive({
      companyInfo: JSON.parse(sessionStorage.getItem("companyInfo")),
      orderInfo: props.params,
      orderRef: "",
      orderForm: {
        origin: 1,
        orderNum: "",
        housePrice: "",
        commission: "",
        cash: "",
        payeeMode: [100],
        remark: "",
      },
      selHouse: [],
      hid: props.params.hid,
      selStime: dayjs().format("YYYY-MM-DD"),
      selEtime: dayjs().add(1, "day").format("YYYY-MM-DD"),
      nights: 1,
      houseInfo: "",
      orderShow: false,
      drawerStyle: {
        backgroundColor: "#f3f3f3",
      },
      bodyStyle: {
        padding: "0",
      },
      activeKey: 1,
      dayRemark: "",
      // 切换tabs
      handleChangeTabs() {
        if (orders.activeKey == 2) {
          orders.getDayRemark();
        }
      },
      // 保存日期备忘
      saveDateRemark() {
        updateDayRemark({
          hid: orders.hid,
          date: orders.selStime,
          remark: orders.dayRemark,
        }).then((res) => {
          message.success(res.msg);
          context.emit("refresh");
        });
      },
      // 获取日期备忘
      getDayRemark() {
        getDayRemark({
          hid: orders.hid,
          date: orders.selStime,
        }).then((res) => {
          orders.dayRemark = res.data.remark;
        });
      },
      // 房间搜索回调
      filterOption(inp, opn) {
        return opn.key.toLowerCase().indexOf(inp.toLowerCase()) >= 0;
      },
      // 选择房间 回调
      hidChange(v) {
        if (props.params.hid) {
          context.emit("refresh", "house", v);
        }
        inits.getHouseDet();
      },
      // 不可选开始时间
      disableStime(date) {
        return date && date >= dayjs(orders.selEtime);
      },
      // 不可选结束时间
      disableEtime(date) {
        return date && date <= dayjs(orders.selStime);
      },
      // 开始时间 回调
      stimeChange(v, s) {
        orders.selStime = s;
      },
      // 结束时间 回调
      etimeChange(v, s) {
        orders.selEtime = s;
      },
      // 保存
      handleSaves() {
        // if (addPersons.personList.length <= 0)
        //   return message.error("请添加入住人");
        orders.orderRef.validate().then(() => {
          inits.loading = true;
          addOrder({
            hid: orders.hid,
            start_date: orders.selStime,
            end_date: orders.selEtime,
            tenant: JSON.stringify(addPersons.personList),
            source_id: orders.orderForm.origin.toString(),
            paytype_id: orders.orderForm.payeeMode.toString(),
            total_amount: orders.orderForm.housePrice,
            royalty: orders.orderForm.commission,
            deposit: orders.orderForm.cash,
            remark: orders.orderForm.remark,
            out_trade_no: orders.orderForm.orderNum,
          })
              .then((res) => {
                orders.orderRef.resetFields();
                message.success(res.msg);
                addPersons.personList = [];
                // addPersons.personRef.resetFields();
                orders.selHouse = [];
                orders.selStime = "";
                orders.selEtime = "";
                // 子组件回调
                context.emit("refresh", "init");
              })
              .finally(() => {
                inits.loading = false;
              });
        });
      },
      // 关闭
      handleCancel() {
        orders.orderInfo.show = false;
        context.emit("refresh", "close");
      },
    });

    // 添加入住人
    const addPersons = reactive({
      personRef: "",
      addPersonShow: false,
      addType: 1,
      editIndex: null,
      personForm: {
        name: "",
        phone: "",
        idcard: "",
      },
      personList: [],

      // 编辑入住人
      handleEditPerson(v, i) {
        addPersons.addType = 2;
        addPersons.editIndex = i;
        addPersons.addPersonShow = true;
        addPersons.personForm = {...v};
      },
      // 删除入住人
      handleDelPerson(v) {
        Modal.confirm({
          title: "提示",
          content: "是否删除?",
          onOk() {
            addPersons.personList.splice(v, 1);
          },
        });
      },

      // 添加入住人
      handleConfirmAdd() {
        addPersons.personRef.validate().then(() => {
          if (addPersons.addType == 1) {
            addPersons.personList.push({
              name: addPersons.personForm.name,
              phone: addPersons.personForm.phone,
              idcard: addPersons.personForm.idcard,
            });
          } else {
            addPersons.personList[addPersons.editIndex] = {
              ...addPersons.personForm,
            };
          }
          addPersons.addPersonShow = false;
          addPersons.personRef.resetFields();
        });
      },
    });

    // 初始化
    const inits = reactive({
      loading: false,
      searchList: [],
      houseList: [],
      getSearch() {
        // 获取查询参数列表
        getSearchList().then((res) => {
          inits.searchList = res.data;
          orders.orderForm.cash = res.data.deposit?.list[0].num || "";
        });
      },
      // 获取房间详情
      getHouseDet() {
        houseDetails({
          hid: orders.hid,
        }).then((res) => {
          orders.houseInfo = res.data;
        });
      },
    });

    watch(
        () => props.params.show,
        (n) => {
          if (n) {
            orders.orderShow = true;
            if (props.params.hid) {
              orders.selStime = props.params.date[0];
              orders.selEtime = dayjs(
                  props.params.date[props.params.date.length - 1]
              )
                  .add(1, "day")
                  .format("YYYY-MM-DD");
              orders.nights = props.params.date.length;
              orders.hid = Number(props.params.hid);
              inits.getHouseDet();
            }
            inits.getSearch();
          } else {
            orders.orderShow = false;
          }
        }
    );

    watch(props, () => {
      if (props.tab) {
        orders.activeKey = props.tab;
        if (orders.activeKey == 2) {
          orders.getDayRemark();
        }
      }
    });

    return {
      verifyPhone,
      verifyIdcard,
      verifyPrice,
      imgCut,
      dayjs,
      diffDate,
      ...toRefs(addPersons),
      ...toRefs(inits),
      ...toRefs(orders),
      ...toRefs(room),
    };
  },
};
</script>

<style lang="scss" scoped>
// 录入订单
.order-box {
  .det-head {
    .ant-tabs-nav {
      height: 50px;
    }

    .close {
      z-index: 999;
      position: fixed;
      right: 24px;
      top: 7px;
      cursor: pointer;

      &:hover {
        color: #000000;
      }
    }
  }

  .box-house {
    margin-bottom: 10px;
    background-color: #ffffff;

    .house-title {
      padding: 10px 0;
      font-weight: bold;
      border-bottom: 1px solid #f3f3f3;
      display: flex;
      // align-items: center;
      .title_img {
        // border-radius: 4px;
        overflow: hidden;
        margin-right: 10px;
      }

      .title_name {
        .room-info {
          background-color: #fff;
          border: 1px solid #d9d9d9;
          border-radius: 2px;
          display: flex;
          min-width: 200px;
          min-height: 32px;
          cursor: pointer;
          justify-content: space-between;
          align-items: center;
          padding: 0 11px;

          &:hover {
            border: 1px solid #1890ff;
          }
        }
      }
    }

    .house-date {
      padding: 20px 0 0 0;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .date-time {
        text-align: center;

        .time-top {
        }

        .time-bom {
          color: #999;
        }
      }

      .date-night {
        border: 1px solid #f3f3f3;
        border-radius: 4px;
        padding: 2px 8px;

        span {
          padding: 0 2px;
        }
      }
    }
  }

  .box-person {
    margin-bottom: 10px;
    background-color: #ffffff;

    .person-title {
      border-bottom: 1px solid #f3f3f3;
      display: flex;
      justify-content: space-between;
      padding: 10px 0;

      .title-left {
        font-weight: bold;
      }

      .title-right {
        cursor: pointer;
        color: #0094ff;
      }
    }

    .person-list {
      .list_cont {
      }

      .list_inp {
        padding: 20px 5px;

        .person_add {
          cursor: pointer;
          display: flex;
          justify-content: center;

          .add_confirm {
            background-color: #0094ff;
            color: #fff;
            border-radius: 4px;
            padding: 2px 10px;
            margin-right: 10px;
          }

          .add_cancel {
            background-color: #f3f3f3;
            border-radius: 4px;
            padding: 2px 10px;
          }
        }
      }

      padding: 0 10px;

      .list-cell {
        display: flex;
        padding: 3px 0;

        .cell-name {
          flex: 3;
        }

        .cell-phone {
          flex: 4;
        }

        .cell-oper {
          flex: 3;
          text-align: right;

          span {
            padding: 0 3px;
          }

          .oper-del {
            cursor: pointer;
            color: #dd0054;
          }

          .oper-edit {
            cursor: pointer;
            color: #0094ff;
          }
        }
      }
    }
  }

  .box-info {
    background-color: #fff;
    padding-bottom: 5px;

    .info-title {
      border-bottom: 1px solid #f3f3f3;
      padding: 10px 0;
      font-weight: bold;
    }

    .info-form {
      padding: 20px 0;
    }
  }
}
</style>
